import { useEffect, useState } from "react";
import HeaderBar from "../../../components/header/headerBar";
import { SearchFieldSelect } from "../../../components/textfield";
import Select from "../../../components/select/select";
import "../../../assets/styles/admin/systemlog.scss";
// import { Table, TableColumn } from "../../../components/table";
import axios from "axios";
import { Row, Pagination, Table } from "antd";
import moment from "moment";
const SystemLog = () => {
  const [branchs, setBranchs] = useState<string>("");
  const [months, setMonths] = useState<string>("");
  const [state, setState] = useState<any>([]);
  const [datas, setDatas] = useState<any>([]);

  const [page, setPage] = useState(1);
  const [countPage, setCountPage] = useState(1);

  const option = [{ value: "name", name: "Name" }];
  const branch = [
    { value: "", name: "All" },
    { value: "1", name: "1" },
    { value: "2", name: "2" },
  ];

  const month = [
    { value: "", name: "All" },
    { value: "1", name: "1" },
    { value: "2", name: "2" },
  ];

  const column = [
    {
      title: "",
      dataIndex: "numcol",
    },

    {
      title: "รหัสลูกค้า / CN",
      dataIndex: "cn",
      align: "center" as const,
      render: (data: any) => {
        return !data?.cn ? "-" : data?.cn;
      },
    },
    {
      title: "รหัสพนักงาน / EN",
      dataIndex: "en",
      align: "center" as const,
    },
    {
      title: "ชื่อพนักงาน / Keyman",
      dataIndex: "modelName",
      align: "center" as const,
    },
    {
      title: "บันทึกวันที่ / Date Log",
      dataIndex: "updatedAt",
      align: "center" as const,
      render: (data: any) => {
        return moment(data).utcOffset(0, true).format("DD-MM-YYYY hh:mm A");
        //  +
        // " " +
        // data.substring(11, 19).format("")
      },
    },
    {
      title: "ตาราง / Table Name",
      dataIndex: "tablename",
      align: "center" as const,
      render: (data: any) => {
        return !data?.tablename ? "-" : data?.tablename;
      },
    },
    {
      title: "คำอธิบาย / Description",
      dataIndex: "action",
      align: "center" as const,
    },
    {
      title:
        "ชื่อเครื่องคอมพิวเตอร์(รหัสเครื่องคอมพิวเตอร์) / Computer Name(Mac Address)",
      dataIndex: "ipAddress",
      align: "center" as const,
      render: (data: any) => {
        return !data?.ipAddress ? "-" : data?.ipAddress;
      },
    },
    {
      title: "สาขา / Branch",
      dataIndex: "branch",
      align: "center" as const,
    },
  ];

  const onChangeOtherd = (index: string) => {
    console.log("index xxx => ", index);
  };

  const getAPIs = async () => {
    console.log("page", page);

    // await axios.get(`/logs?page=${page}`).then((res) => {
    await axios.get(`/logs`).then((res) => {
      // console.log("state x ", res?.data);
      setCountPage(res?.data?.pages);

      let datas = res?.data?.models?.data;
      console.log("res", datas);
      const count = datas.map((data: any, index: number) => ({
        ...data,
        numcol: index + 1,
      }));
      setState(count);
    });
  };
  const onchangePage = (page: any) => {
    setPage(page);
    getAPIs();
  };
  useEffect(() => {
    getAPIs();
  }, []);
  return (
    <>
      <HeaderBar title="บันทึกส่วนระบบ / System Log List" />
      <div style={{ padding: "10px 40px" }}>
        <SearchFieldSelect
          option={option}
          color="#FFF"
          placeholder=""
          onChangeOtherd={onChangeOtherd}
        />
        <div className="row mt-20">
          <div className="systemWapper">
            <div className="system-select">
              <div className="col-2">
                {/* <div className="systemlog-title">
                  <Select
                    title="BRANCH :"
                    option={branch}
                    value={branchs}
                    onChange={(e) => {
                      setBranchs(e.target.value);
                    }}
                  />
                </div>
              </div> */}
                {/* <div className="col-2">
                <div className="systemlog-title">
                  <Select
                    title="MONTH :"
                    option={month}
                    value={months}
                    onChange={(e) => {
                      setMonths(e.target.value);
                    }}
                  />
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-20">
          <Table
            columns={column}
            dataSource={state}
            scroll={{ x: 1200 }}
            bordered
          />
        </div>
      </div>
    </>
  );
};
export default SystemLog;
